

import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackStyling, formLabelStyling, descriptionStyling, dropDownFormStyle } from 'components/forms/new/formStyles';

const options = [
    { label: '1', value: '1' },
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '100', value: '100' },
];


const NumberBlockSizeField = ({ darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
        sx={{ margin: '0 !important' }}
            // isInvalid={!!errorMsg}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row"  sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Block Size <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the block size for this number block rate.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'flex-start',
                                                                               marginTop: '24px',
                                                                            }}>
                        <VStack width="100%" alignItems="normal">
                            <Field name="size" validate={value => !value ? 'Block size is required' : undefined}>
                                {({ form, meta }) => {
                                    const error = meta.error;
                                    const showError = meta.touched;
                                    let errorMsg = undefined;
                                    if (showError) {
                                        if (!form.values.size) {
                                            errorMsg = 'Please select a block size.';
                                        } else if (error) {
                                            errorMsg = error;
                                        }
                                    }
                                    return (
                                        <>
                                            <Select
                                                placeholder="- Select Block Size -"
                                                value={options.find(opt => opt.value === String(form.values.size)) || null}
                                                onChange={e => {
                                                    form.setFieldValue('size', e.value);
                                                    form.validateField('size');
                                                }}
                                                options={options}
                                                chakraStyles={dropDownFormStyle(darkMode)}
                                                menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                onBlur={() => form.setFieldTouched('size', true)}
                                            />
                                            {!!errorMsg && (
                                                <Text color="red.500" fontSize="xs" mt={1} textAlign="right">
                                                    {errorMsg}
                                                </Text>
                                            )}
                                        </>
                                    );
                                }}
                            </Field>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the block size."
                        ariaLabel="number-block-size-tip"
                        left="25px"
                        top="30px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default NumberBlockSizeField;
